import { useState, useEffect } from "react";
import { imageLoadingQueue } from "@/lib/image-loading-queue";

interface UseImageOptions {
  imageUrl: string | null | undefined;
  isVisible: boolean;
}

export function useImage({ imageUrl, isVisible }: UseImageOptions) {
  const [imageUrlState, setImageUrlState] = useState<string | null>(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (!isVisible) return;

    let cancelled = false;

    const loadImage = async () => {
      // Only load if we have a database imageUrl
      if (!imageUrl) {
        setImageLoading(false);
        setImageError(true);
        return;
      }

      setImageLoading(true);
      setImageError(false);

      // Create cache key
      const cacheKey = imageUrl;

      try {
        const result = await imageLoadingQueue.loadImage(imageUrl, cacheKey);
        if (!cancelled) {
          if (result) {
            setImageUrlState(result);
            setImageLoading(false);
          } else {
            setImageLoading(false);
            setImageError(true);
          }
        }
      } catch (error) {
        if (!cancelled) {
          setImageLoading(false);
          setImageError(true);
        }
      }
    };

    loadImage();

    return () => {
      cancelled = true;
    };
  }, [isVisible, imageUrl]);

  return {
    imageUrl: imageUrlState,
    imageLoading,
    imageError,
  };
}
